export function isZeroOrEmpty(v: string | undefined) {
  return v === '' || Number(v) === 0;
}
